/** 16:9 trailers (Payday) often ship cinematic bars inside the file. Wider crops do not. */
const SIXTEEN_NINE = 16 / 9;
const SIXTEEN_NINE_SLACK = 0.05;

/**
 * Measured on the PAYDAY 2 trailer: 56/480 top, 59/480 bottom. Crop a little past that
 * so a leftover black foot cannot sit in the fade.
 */
export const CINEMATIC_LETTERBOX_FRACTION = 0.15;

export interface LetterboxCrop {
  top: number;
  bottom: number;
}

export const resolveLetterboxCrop = (width: number, height: number): LetterboxCrop => {
  if (width <= 0 || height <= 0) return { top: 0, bottom: 0 };
  const aspect = width / height;
  if (Math.abs(aspect - SIXTEEN_NINE) <= SIXTEEN_NINE_SLACK) {
    return { top: CINEMATIC_LETTERBOX_FRACTION, bottom: CINEMATIC_LETTERBOX_FRACTION };
  }
  return { top: 0, bottom: 0 };
};

export const letterboxContentFraction = (crop: LetterboxCrop): number => {
  const content = 1 - crop.top - crop.bottom;
  return content > 0 ? content : 1;
};
